import React, { SVGAttributes } from 'react';

/** Android device frame without the iOS notch/dynamic island. */
export function AndroidPhoneWrapper(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg width='370' height='802' viewBox='0 0 370 802' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M316 0H54C24.2 0 0 24.9 0 55.6V746c0 30.7 24.2 55.7 54 55.7h262c29.8 0 54-25 54-55.7V55.6C370 24.9 345.8 0 316 0Zm42.9 55.6V746c0 24.4-19.2 44.1-42.9 44.1H54c-23.7 0-42.9-19.7-42.9-44.1V55.6c0-24.4 19.2-44.1 42.9-44.1h262c23.7 0 42.9 19.7 42.9 44.1Z'
        fill='url(#android-phone-gradient)'
      />
      <defs>
        <linearGradient id='android-phone-gradient' x1='370' y1='618' x2='-289' y2='748' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#323232' />
          <stop offset='0.8' />
        </linearGradient>
      </defs>
    </svg>
  );
}
